// @ts-nocheck
import {assortments, getUserObject} from "utils/relewise";

function getProductsViewedAfterViewingProductObject(options) {
  let filter1 = {
    $type: "Relewise.Client.Requests.Filters.ProductCategoryIdFilter, Relewise.Client",
    CategoryIds: options.collections,
    EvaluationScope: "Ancestor",
    TypeName: "ProductCategoryIdFilter",
  };

  let filter2 = {
    $type: "Relewise.Client.Requests.Filters.ProductDataFilter, Relewise.Client",
    Key: "Vendor",
    FilterOutIfKeyIsNotFound: true,
    MustMatchAllConditions: true,
    Conditions: {
      Items: [
        {
          $type: "Relewise.Client.Requests.Conditions.EqualsCondition, Relewise.Client",
          Value: {
            Value: options.vendor,
          },
          TypeName: "EqualsCondition",
        },
      ],
    },
    TypeName: "ProductDataFilter",
  };

  if (options.c2s) {
    filter1 = {
      $type: "Relewise.Client.Requests.Filters.ProductDataFilter, Relewise.Client",
      Key: "Vendor",
      FilterOutIfKeyIsNotFound: true,
      MustMatchAllConditions: true,
      Conditions: {
        Items: [
          {
            $type:
                "Relewise.Client.Requests.Conditions.EqualsCondition, Relewise.Client",
            Value: {
              Value: "MOS MOSH DK", // All DK C2S products are having this Vendor
            },
            TypeName: "EqualsCondition",
          },
        ],
      },
      TypeName: "ProductDataFilter",
    };

    filter2 = {
      $type: "Relewise.Client.Requests.Filters.ProductDataFilter, Relewise.Client",
      Key: "Reloved",
      FilterOutIfKeyIsNotFound: true,
      MustMatchAllConditions: true,
      Conditions: {
        Items: [
          {
            $type:
                "Relewise.Client.Requests.Conditions.EqualsCondition, Relewise.Client",
            Value: {
              Type: "Boolean",
              Value: true,
            },
            TypeName: "EqualsCondition",
          },
        ],
      },
      TypeName: "ProductDataFilter",
    };
  }

  return {
    ProductAndVariantId: {
      ProductId: options.crossStoreProductId,
      VariantId: options.variantId,
    },
    Settings: {
      NumberOfRecommendations: 10,
      AllowFillIfNecessaryToReachNumberOfRecommendations: true,
      AllowReplacingOfRecentlyShownRecommendations: true,
      RecommendVariant: true,
      SelectedProductProperties: {
        DisplayName: true,
        Pricing: true,
      },
      SelectedVariantProperties: {
        DisplayName: true,
        Pricing: true,
        DataKeys: [
          "COM_ShopifyHandle",
          "DE_ShopifyHandle",
          "DK_ShopifyHandle",
          "SE_ShopifyHandle",
          "ImageUrls",
        ],
      },
    },
    Filters: {
      Items: [
        filter1,
        {
          $type:
              "Relewise.Client.Requests.Filters.ProductAssortmentFilter, Relewise.Client",
          Assortments: [assortments[window.mosmosh.shop_code]],
          TypeName: "ProductAssortmentFilter",
        },
        {
          $type:
              "Relewise.Client.Requests.Filters.VariantAssortmentFilter, Relewise.Client",
          Assortments: [assortments[window.mosmosh.shop_code]],
          TypeName: "VariantAssortmentFilter",
        },
        filter2,
      ],
    },
    Language: {
      Value: window.mosmosh.shop_local.iso,
    },
    User: getUserObject(),
    DisplayedAtLocationType: options.c2s ? "Product Detail page - ReLoved" : "Product detail page",
    Currency: {
      Value: window.mosmosh.currency.iso,
    },
  };
}

export default getProductsViewedAfterViewingProductObject
